import common from '@/common/mixins/common.js'
import page from '@/common/mixins/page.js'
import {
	mapActions
} from 'vuex'
import Moment from 'moment'
export default {
	inject: ['adminLayout'],
	mixins: [common, page],
	data() {
		return {
			queryForm: {
				date: [
					Moment().startOf('day').add(-1, 'day').format('YYYY-MM-DD'),
					Moment().startOf('day').add(-1, 'day').format('YYYY-MM-DD')
				],
				group: 0,
				accountName: '',
				site: ''
			},
			tableData: [],
			q: {
				startDate: Moment().startOf('day').add(-1, 'day').format('YYYY-MM-DD'),
				endDate: Moment().startOf('day').add(-1, 'day').format('YYYY-MM-DD')
			},
			namespace: '',
			fetchOnCreated: false
		}
	},
	created() {
		const {
			startDate,
			endDate,
			group,
			site,
			accountName
		} = this.$route.query
		if (startDate && endDate && /\d{4}-\d{2}-\d{2}/.test(startDate) && /\d{4}-\d{2}-\d{2}/.test(endDate)) {
			this.queryForm.date = [startDate, endDate]
			this.q.startDate = startDate
			this.q.endDate = endDate
		}
		if (group && /^(0)|(1)$/.test(group)) {
			this.queryForm.group = Number(group)
		}
		if (site) {
			this.queryForm.site = site
		}
		if (accountName) {
			this.queryForm.accountName = accountName
		}
		this.searchEvent(false)
	},
	methods: {
		buildQueryForm(queryForm) {
			let query = {};
			for (let key in queryForm) {
				if (queryForm.hasOwnProperty(key) && (queryForm[key].length > 0 || typeof(queryForm[key]) ===
						'boolean') || typeof(queryForm[key]) === 'number') {
					if (key === 'date') {
						const [startDate, endDate] = queryForm[key]
						query['startDate'] = startDate
						query['endDate'] = endDate
					} else {
						query[key] = queryForm[key]
					}
				}
			}
			return query;
		},
		buildSearch(query) {
			let search = []
			for (let key in query) {
				if (Array.isArray(query[key])) {
					search.push(`${key}=${query[key].join(',')}`)
				} else {
					search.push(`${key}=${query[key]}`)
				}
			}
			return search.join('&')
		},
		searchEvent(showErr = true) {
			this.q = this.buildQueryForm(this.queryForm)
			const search = this.buildSearch(this.q)
			history.replaceState(this.q, '', `${window.location.pathname}?${search}`)
			this.getList()
		},
		handleRawData(content) {
			this.tableData = this.handlePangleSiteData(content)
		},
		handlePangleSiteData(content) {
			return content.map(v => {
				const costDate = this.q.group === 0 ? `${this.q.startDate}~${this.q.endDate}` : Moment(Number(v.costDate)*1000).format('YYYY-MM-DD')
				const conversion = Number(v.conversion)
				const epc = conversion > 0 ? (Number(v.revenue) / conversion) : 0 
				return {
					...v,
					costDate,
					conversion,
					epc
				}
			})
		},
		async getListUrl() {
			if (this.namespace === '') return
			const trigger = this.trigger
			return this.$store.dispatch(`${this.namespace}/fetchJSCXPangleSiteReport`, {
				...this.q
			})
		},
		downloadTask() {
			const q = this.buildQueryForm(this.queryForm)
			this.$store.commit('download-manager/addTask', {
				action: `${this.namespace}/fetchJSCXPangleSiteReport`,
				payload: {
					...q
				},
				title: `JSCX_PangleSiteReport_(${q.startDate}~${q.endDate})`,
				dispatch: this.$store.dispatch,
				responseHandler: (content) => {
					return {
						content: this.handlePangleSiteData(content),
						totalPages: 1
					}
				}
			})
		}
	}
}